import Swiper from 'swiper';
import {Navigation, Pagination, EffectCreative, Autoplay } from 'swiper/modules';
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay]);

const logoSlider = new Swiper('.logo-slider', {
  loop: true,
  loopAdditionalSlides: 8,
  slidesPerView: 'auto',
  spaceBetween: 40,
  speed: 4000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  allowTouchMove: false,
});


const wrapper = document.querySelector('.logo-slider .swiper-wrapper');
const slides = [...wrapper.children];
slides.forEach(slide => {
  const clone = slide.cloneNode(true);
  wrapper.appendChild(clone);
});
